import React, {useState, useEffect} from 'react'
import HomeLg from './components/HomeLg'
import HomeSm from './components/HomeSm'

function Home() {

    const [width, setWidth] = useState(window.innerWidth);
    const isMobile = width <= 768;

    useEffect(()=>{
        window.scrollTo(0, 0);
    }, [])
    
    if(isMobile){
        return (<HomeSm />)
    }else{
        return (<HomeLg />)
    }
    
}

export default Home